<template>
  <div>
    <div
      ref="menu"
      class="tippy-holder flex flex-row justify-center items-center"
      
    >
      <div
        class="bubble-menu bg-white rounded-lg p-1 mb-1 shadow-lg flex flex-row justify-center"
      >

        <button
          class="menu"
          v-tooltip="'Clone Code Block'"
          @click="copyContent"
        >
          <span class="material-icons">
            content_copy
          </span>
        </button>

      </div>

      <div class="outer__menu flex flex-row">

        <div @click="closeMenu" v-tooltip="'Close Menu'">
          <svg-icon
            icon="heroicons/outline/x"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
          />
        </div>

        <div @click="$emit('delete-content', model)">
          <svg-icon
            icon="heroicons/outline/trash"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
            v-tooltip="'Delete Code Block'"
          />
        </div>
      </div>
    </div>

<div class="code-wrap rounded-lg relative pb-3 pt-4 pl-4 pr-2 mx-auto" style="background-color: #272822">

<div class="flex flex-row">

<div class="flex-grow">

<pre><textarea 
v-model="text"
class="language-html w-full input p-2 focus:outline-none focus:bg-gray-600"
:style="{ height: calcHeight + 80 + 'px'}"></textarea></pre>

</div>

<div class="flex-none">
<div ref="settings" class="handle ml-1"       
v-tooltip="{
        content: '<b>Drag</b> to move<br /><b>Click</b> to open menu',
      }">
<span class="material-icons cursor-pointer text-gray-300 hover:text-purple-300">
settings
</span>
</div>

</div>
</div>
</div>

  </div>
</template>

<script>

//import { component as VueCodeHighlight } from 'vue-code-highlight';
import tippy from "tippy.js";
//import 'vue-code-highlight/themes/prism.css';
import Code from "@/models/content/CodeField";

export default {
  components: {
    //VueCodeHighlight

  },

  data() {
    return {
    };
  },

  props: ["content_id", "step", "survey", "dragging"],

  computed: {

    cssVars() {
      return {
        "--font-size": this.fontSize + "px",
        "--font-family": this.survey.fontFamily
      };
    },

    model() {
      return Code.find(this.content_id);
    },

    text: {
      get() {
        return this.model.text;
      },
      set(value) {
        console.log('updating ..' + value)
        Code.update({
          where: this.content_id,
          data: { text: value },
        });
      },
    },

    fontSize: {
      get() {
        return this.model.fontSize;
      },
      set(num) {
        Code.update({
          where: this.content_id,
          data: { fontSize: num },
        });
      },
    },
    calcHeight() {
  let numberOfLineBreaks = (this.text.match(/\n/g) || []).length;
  // min-height + lines x line-height + padding + border
  let newHeight = 20 + numberOfLineBreaks * 20 + 12 + 2;
  return newHeight;
}
  },
  methods: {
    closeMenu(event) {
    //Close BubbleMenu created by Tippy.js directly (w/o editor)
      this.bubbleMenu.hide();
      //this.closecolorSettings(event);
    },

    addFont() {
      this.fontSize++;
    },
    subtractFont() {
      this.fontSize--;
    },
    copyContent(){
      this.$emit("copy-content", this.model);
    },
  },

  mounted() {
    let target = this.$refs.settings;
    let menu = this.$refs.menu;

    this.bubbleMenu = tippy(target, {
      content: menu,
      interactive: true,
      duration: 10,
      maxWidth: "none",
      hideOnClick: false,
      trigger: "click",
      onClickOutside(instance, event) {
        instance.hide();
      },
    });
  },

  destroyed() {
    window.removeEventListener("keydown", this.onEscape);
  },


};
</script>

<style>
pre textarea {
  display: block;
  overflow-wrap: break-word;
  white-space: pre;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  overflow-y: hidden;
  padding: 16px;
  color: #f8f8f2;
  background: none;
  text-shadow: 0 1px rgba(0, 0, 0, 0.3);
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  background: #272822;
  
}


</style>
